/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import VisibilitySensor from "react-visibility-sensor";


import { IObrienPerformanceNumbersViewProps } from './obrien-performance-numbers';
import { performanceAnimation1, performanceAnimation2, performanceAnimation3, performanceAnimation4, performanceAnimation5 } from './obrien-performance-numbers.props.autogenerated';



const _performanceOne=(): JSX.Element => {
    return (
            
        <>
            <div className="box-front">
                <div className="number">1</div>
            </div>
            <div className="black-box box1"></div>
        </>
        
       
    );
};

const _performanceTwo=(): JSX.Element => {
    return (
    
        <>
            <div className="box-front">
                <div className="number">2</div>
            </div>
            <div className="black-box box1"></div>
            <div className="black-box box2"></div>
        </>
       
    );
};

const _performanceThree=(): JSX.Element => {
    return (
    
        <>
            <div className="box-front">
                <div className="number">3</div>
            </div>
            <div className="black-box box1"></div>
            <div className="black-box box2"></div>
            <div className="black-box box3"></div>
        </>
    );
   
};

const _performanceFour=(): JSX.Element => {
    return (
    
        <>
            <div className="box-front">
                <div className="number">4</div>
            </div>
            <div className="black-box box1"></div>
            <div className="black-box box2"></div>
            <div className="black-box box3"></div>
            <div className="black-box box4"></div>
        </>
      
    );
};

const _performanceFive=(): JSX.Element => {
    return (
        <>
            
            <div className="box-front">  
                <div className="number">5</div>
            </div>
            <div className="black-box box1"></div>
            <div className="black-box box2"></div>
            <div className="black-box box3"></div>
            <div className="black-box box4"></div>
            <div className="black-box box5"></div>

        </>

    )
    
};




export default (props: IObrienPerformanceNumbersViewProps) => {

    const { 
        performanceTitle1, performanceTitle2, performanceTitle3, performanceTitle4, performanceTitle5,
        performanceAnimationOne, performanceAnimationTwo, performanceAnimationThree, performanceAnimationFour, performanceAnimationFive
    } = props;

    //@ts-ignore
    let p1one; let p1two; let p1three; let p1four; let p1five;
    if (performanceAnimationOne === performanceAnimation1.p1one) {
        p1one = _performanceOne();
    }
    if (performanceAnimationOne === performanceAnimation1.p1two) {
        p1two = _performanceTwo();
    }
    if (performanceAnimationOne === performanceAnimation1.p1three) {
        p1three = _performanceThree();
    }
    if (performanceAnimationOne === performanceAnimation1.p1four) {
        p1four = _performanceFour();
    }
    if (performanceAnimationOne === performanceAnimation1.p1five) {
        p1five = _performanceFive();
    }
    //@ts-ignore
    let p2one; let p2two; let p2three; let p2four; let p2five;
    if (performanceAnimationTwo === performanceAnimation2.p2one) {
    p2one = _performanceOne();
    }
    if (performanceAnimationTwo === performanceAnimation2.p2two) {
    p2two = _performanceTwo();
    }
    if (performanceAnimationTwo === performanceAnimation2.p2three) {
    p2three = _performanceThree();
    }
    if (performanceAnimationTwo === performanceAnimation2.p2four) {
    p2four = _performanceFour();
    }
    if (performanceAnimationTwo === performanceAnimation2.p2five) {
    p2five = _performanceFive();
    }

    //@ts-ignore
    let p3one; let p3two; let p3three; let p3four; let p3five;
    if (performanceAnimationThree === performanceAnimation3.p3one) {
        p3one = _performanceOne();
    }
    if (performanceAnimationThree === performanceAnimation3.p3two) {
        p3two = _performanceTwo();
    }
    if (performanceAnimationThree === performanceAnimation3.p3three) {
        p3three = _performanceThree();
    }
    if (performanceAnimationThree === performanceAnimation3.p3four) {
        p3four = _performanceFour();
    }
    if (performanceAnimationThree === performanceAnimation3.p3five) {
        p3five = _performanceFive();
    }

    //@ts-ignore
    let p4one; let p4two; let p4three; let p4four; let p4five;
    if (performanceAnimationFour === performanceAnimation4.p4one) {
        p4one = _performanceOne();
    }
    if (performanceAnimationFour === performanceAnimation4.p4two) {
        p4two = _performanceTwo();
    }
    if (performanceAnimationFour === performanceAnimation4.p4three) {
        p4three = _performanceThree();
    }
    if (performanceAnimationFour === performanceAnimation4.p4four) {
        p4four = _performanceFour();
    }
    if (performanceAnimationFour === performanceAnimation4.p4five) {
        p4five = _performanceFive();
    }

    //@ts-ignore
    let p5one; let p5two; let p5three; let p5four; let p5five;
    if (performanceAnimationFive === performanceAnimation5.p5one) {
        p5one = _performanceOne();
    }
    if (performanceAnimationFive === performanceAnimation5.p5two) {
        p5two = _performanceTwo();
    }
    if (performanceAnimationFive === performanceAnimation5.p5three) {
        p5three = _performanceThree();
    }
    if (performanceAnimationFive === performanceAnimation5.p5four) {
        p5four = _performanceFour();
    }
    if (performanceAnimationFive === performanceAnimation5.p5five) {
        p5five = _performanceFive();
    }




return (
        
    
                <div className="inside-xl">
                    <div className="flex-gauge top-graph">


                    

                    
                        {performanceAnimationOne && performanceAnimationOne.length > 0 ? (
                            <VisibilitySensor partialVisibility>
                                {({isVisible}) =>
                                    
                                    <div className={isVisible ? "p1 graph isvisible" : "p1 graph"}>
                                        <div className="graphGauge">
                                            <div className="frack top" /><div className="frack right" /><div className="frack bottom" /><div className="frack left" />
                                            {//@ts-ignore
                                            p1one}
                                            {//@ts-ignore
                                            p1two}
                                            {//@ts-ignore
                                            p1three}
                                            {//@ts-ignore
                                            p1four}
                                            {//@ts-ignore
                                            p1five}
                                        </div>
                                        <div className="title">{performanceTitle1}</div>
                                    </div>
                                    
                                }
                            </VisibilitySensor>
                        ) : null}

                        {performanceAnimationTwo && performanceAnimationTwo.length > 0 ? (
                            <VisibilitySensor partialVisibility>
                                {({isVisible}) =>
                                    
                                    <div className={isVisible ? "p2 graph isvisible" : "p2 graph"}>
                                        <div className="graphGauge">
                                            <div className="frack top" /><div className="frack right" /><div className="frack bottom" /><div className="frack left" />
                                            {//@ts-ignore
                                            p2one}
                                            {//@ts-ignore
                                            p2two}
                                            {//@ts-ignore
                                            p2three}
                                            {//@ts-ignore
                                            p2four}
                                            {//@ts-ignore
                                            p2five}
                                        </div>
                                        <div className="title">{performanceTitle2}</div>
                                    </div>
                                    
                                }
                            </VisibilitySensor>
                        ) : null}

                        {performanceAnimationThree && performanceAnimationThree.length > 0 ? (
                            <VisibilitySensor partialVisibility>
                                {({isVisible}) =>
                                    
                                    <div className={isVisible ? "p3 graph isvisible" : "p3 graph"}>
                                        <div className="graphGauge">
                                            <div className="frack top" /><div className="frack right" /><div className="frack bottom" /><div className="frack left" />
                                            {//@ts-ignore
                                            p3one}
                                            {//@ts-ignore
                                            p3two}
                                            {//@ts-ignore
                                            p3three}
                                            {//@ts-ignore
                                            p3four}
                                            {//@ts-ignore
                                            p3five}
                                        </div>
                                        <div className="title">{performanceTitle3}</div>
                                    </div>
                                    
                                }
                            </VisibilitySensor>
                        ) : null}

                        {performanceAnimationFour && performanceAnimationFour.length > 0 ? (
                            <VisibilitySensor partialVisibility>
                                {({isVisible}) =>
                                    
                                    <div className={isVisible ? "p4 graph isvisible" : "p4 graph"}>
                                        <div className="graphGauge">
                                            <div className="frack top" /><div className="frack right" /><div className="frack bottom" /><div className="frack left" />
                                            {//@ts-ignore
                                            p4one}
                                            {//@ts-ignore
                                            p4two}
                                            {//@ts-ignore
                                            p4three}
                                            {//@ts-ignore
                                            p4four}
                                            {//@ts-ignore
                                            p4five}
                                        </div>
                                        <div className="title">{performanceTitle4}</div>
                                    </div>
                                    
                                }
                            </VisibilitySensor>
                        ) : null}

                        {performanceAnimationFive && performanceAnimationFive.length > 0 ? (
                            <VisibilitySensor partialVisibility>
                                {({isVisible}) =>
                                    
                                    <div className={isVisible ? "p5 graph isvisible" : "p5 graph"}>
                                        <div className="graphGauge">
                                            <div className="frack top" /><div className="frack right" /><div className="frack bottom" /><div className="frack left" />
                                            {//@ts-ignore
                                            p5one}
                                            {//@ts-ignore
                                            p5two}
                                            {//@ts-ignore
                                            p5three}
                                            {//@ts-ignore
                                            p5four}
                                            {//@ts-ignore
                                            p5five}
                                        </div>
                                        <div className="title">{performanceTitle5}</div>
                                    </div>
                                    
                                }
                            </VisibilitySensor>
                        ) : null}

                        
                    </div>
                </div>
                

          
        
   
    );
};

